// store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './ducks';

export const store = configureStore({
  reducer: rootReducer,
});

export type AppDispatch = typeof store.dispatch;
